import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { firstValueFrom, Observable } from 'rxjs';
import { PreferenceSettings } from './preferences.interface';

@Injectable({
  providedIn: 'root',
})
export class PreferencesGatewayService {
  protected readonly config = inject<ConfigOptions>(ConfigService);
  protected readonly http = inject(HttpClient);

  protected readonly path = 'preference-settings';

  getAll(
    headers?:
      | HttpHeaders
      | {
          [header: string]: string | string[];
        },
  ): Observable<PreferenceSettings> {
    return this.http.get<PreferenceSettings>(
      `${this.config.host}/${this.path}`,
      { headers },
    );
  }

  updateSetting(
    settingId: string,
    settings: Partial<Exclude<PreferenceSettings, 'preferenceSettingRole'>>,
  ) {
    return firstValueFrom(
      this.http.patch(
        `${this.config.host}/${this.path}/${settingId}`,
        settings,
      ),
    );
  }

  updateRoleSetting(
    settingId: string,
    settings: {
      id: string;
      isEnabled: boolean;
    },
  ) {
    return firstValueFrom(
      this.http.patch(`${this.config.host}/${this.path}/${settingId}`, {
        preferenceSettingRole: settings,
      }),
    );
  }
}
